export const isInited = () => Boolean(window?.dataLayer?.length);

export async function init() {
  // if (process.env.REACT_APP_NODE_ENV === ENV.DEVELOPMENT) {
  //   return;
  // }
  //
  // const exec = function (w, d, s, l, i) {
  //   w[l] = w[l] || [];
  //   w[l].push({
  //     "gtm.start": new Date().getTime(),
  //     event: "gtm.js",
  //   });
  //   const f = d.getElementsByTagName(s)[0];
  //   const j = d.createElement(s);
  //   const dl = l !== "dataLayer" ? `&l=${l}` : "";
  //   j.async = true;
  //   j.src = `https://www.googletagmanager.com/gtm.js?id=${i}${dl}`;
  //   f.parentNode.insertBefore(j, f);
  // };
  //
  // if (!isInited()) {
  //   exec(window, document, "script", "dataLayer", Config.gtmCode);
  // }
}
